import { Icon, Carousel } from 'antd-mobile';
import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import { showNoDevToast } from '@utils/noDevPageList';

import OfficialPage from '../OfficialPage';
import { customEvent } from '@utils/customEvent';
import { TopNav } from '@common/top-nav/TopNav';
import './CommunityPage.less'

let isTurnToDetail = false
let likeTap = false //防止重复点击
let isReply = false //防止重复点击
const dataType = function(data) {
  return Object.prototype.toString.call(data).match(/^\[object\s(\w+)\]$/)[1]
}
const checkDataType = function(data, typeString) {
  return dataType(data).toLowerCase() === typeString.toLowerCase()
}
const hasOwnProperty = function(data, property) {
  if (typeof data.hasOwnProperty === 'function') {
    return data.hasOwnProperty(property)
  }
  return Object.prototype.hasOwnProperty.call(data, property)
}
const ifHasDataType = function(data, typeArr) {
  return typeArr.some(_type => {
    return checkDataType(data, _type)
  })
}
const getRightAttrVal = function(path, target) {
  ;/\]$/.test(path) && (path = path.slice(0, -1))
  let pathArr = path.replace(/\]?\[|\]\.?/g, '.').split(/\./)
  let len = pathArr.length
  let key
  let result = target
  while (ifHasDataType(result, ['object', 'array']) && len > 0) {
    key = pathArr.shift()
    result = result[key]
    len--
  }
  return result
}
const pickAttrObject = function(attrs, target) {
  let result = {}
  if (checkDataType(attrs, 'object') && checkDataType(target, 'object')) {
    for (let k in attrs) {
      if (hasOwnProperty(attrs, k)) {
        result[k] = getRightAttrVal(attrs[k], target)
      }
    }
  }
  return result
}

export default class CommunityPage extends OfficialPage {
  state = {
    topNavBarData: {
      isDefault: 0,
      type: 3,
      title: '圈组'
    },
    communityId: '',
    communityInfo: {},
    memberInfo: [],
    memberCount: '',
    category: [
      {
        value: 0,
        name: '全部',
        attr: 'category_id'
      }
    ],
    activeCategory: {
      value: 0,
      name: '全部',
      attr: 'category_id'
    },
    carouselImg: [],
    sectionList: [],
    getSectionData: {
      page: 1,
      loading: false,
      nomore: false
    },
    search_value: '',
    imgData: {},
    showAddArticleBtn: true,
    hasCarousel: false,
    backTop: 0,
    showActionSheet: false,
    phoneNumCall: '',
    showBackTopBtn: false,
    showContact: false,
    showReplyBox: false,
    replyBoxFocus: false,
    closeDec: false,
    noticeDec: '',
    keyboardHeight: '50%',
    replyPlaceholder: '我来说两句',
    video_url: '',
    listOtherParam: {
      orderby: '', // 排序(默认按板块排序走)
      top_flag: 0, //如果为1 筛选置顶帖
      hot_flag: 0, //如果为1 筛选精品贴
      start_date: '', // 查询开始日期
      end_date: '', //查询结束日期
      latitude: '', // 纬度
      longitude: '' // 经度
    },
    currentSortbyName: '', // 当前显示的排序名称
    sortModal: {
      // 排序弹窗
      show: false,
      data: [
        {
          name: '最热话题',
          value: 'comment_count'
        },
        {
          name: '最新发表',
          value: 'add_time'
        },
        {
          name: '距离最近',
          value: 'distance'
        },
        {
          name: '最热回复',
          value: 'last_comment_time'
        }
      ]
    },
    replyParam: {
      text: '',
      agent_user_token: '',
      address: '',
      latitude: '',
      longitude: '',
      comment_img_url: '',
      comment_id: '',
      parent_comment_id: '',
      sub_app_id: ''
    },
    commentContentMaxHeight: 0,
    commentContentHeight: 40,
    currentTab: 0,
    topicMoreOperationModal: {
      mode: '', // 话题风格
      show: false, // 是否显示话题操作弹窗
      index: 0, // 当前被操作话题下标
      isAuthor: false, // 是否是作者自己的话题
      articleId: '', // 话题id
      sectionId: '', // 版块id
      franchisee: '', // 子店app_id
      isChargeTop: false, // 是否为置顶收费话题
      phone: '' // 联系手机号
    },
    vistorUserToken: '',
    sectionCommentLikeCounts: {
      comment_count: 0, // 社区话题被评论的次数
      like_count: 0, // 社区话题被点赞的次数
      show_type: 0 // 最新消息类型 0： 评论， 1： 点赞
    }
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    let communityId = options.detail
    let that = this
    let franchisee = options.franchisee || ''
    this.setData({
      communityId: communityId,
      franchisee: franchisee,
      ['replyParam.sub_app_id']: franchisee,
      sessionFrom: options.franchisee || app.getAppId() || ''
    })
    app.globalData.communityPageRefresh = false
    if (app.isLogin()) {
      that.getSectionInfo(communityId, function() {
        that.getMemberInfo(communityId)
        that.getCategory(communityId)
      })
      this.setData({
        vistorUserToken: (app.getUserInfo() || {})['user_token'] || ''
      })
    } else {
      app.goLogin({
        success: function() {
          that.getSectionInfo(communityId, function() {
            that.getMemberInfo(communityId)
            that.getCategory(communityId)
          })
          that.setData({
            vistorUserToken: (app.getUserInfo() || {})['user_token'] || ''
          })
        }
      })
    }
    this.systemInfo = app.getSystemInfoSync()
    this.getSysnInfoTimer = setTimeout(() => {
      let systemInfo = app.getSystemInfoSync()
      if (systemInfo.windowHeight !== this.systemInfo.windowHeight) {
        this.systemInfo = systemInfo
      }
    }, 500)
    that.getSectionCommentLikeCount()
  }

  componentDidShow() {
    if (app.globalData.communityPageRefresh) {
      this.setData({
        getSectionData: {
          page: 1,
          loading: false,
          nomore: false
        },
        sectionList: []
      })
      app.globalData.communityPageRefresh = false
      this.getSectionList()
      this.getSectionCommentLikeCount()
    }
    isTurnToDetail = false
  }

  getSectionInfo = (sId, callback) => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=AppSNS/GetSectionByPage',
      data: {
        section_id: sId,
        page: 1,
        page_size: 100,
        sub_app_id: that.data.franchisee
      },
      method: 'post',
      success: function(res) {
        if (res.status == 0) {
          let info = res.data[0] || {}
          that.setData({
            communityInfo: info,
            showContact: info.require_phone == 1,
            showArticleComment: info.show_article_comment == 1,
            'topNavBarData.type': info.article_style == 3 ? '4' : '3'
          })
          app.setStorage({
            key: 'communityThemeColor-' + info.id,
            data: info.theme_color
          })
          if (info.has_carousel == 1) {
            that.getCarousel(sId)
            that.setData({
              hasCarousel: true
            })
          }
          typeof callback == 'function' && callback(res)
        }
      }
    })
  }
  getMemberInfo = sId => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=AppSNS/GetSectionJoinUserList',
      data: {
        section_id: sId
      },
      method: 'post',
      success: function(res) {
        if (res.status == 0) {
          let memberInfo = res.data
          let memberCount = res.user_total
          that.setData({
            memberInfo: memberInfo,
            memberCount: memberCount
          })
        }
      }
    })
  }
  getCategory = sId => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=AppSNS/GetCategoryByPage',
      data: {
        section_id: sId,
        page: 1,
        page_size: 100,
        sub_app_id: that.data.franchisee
      },
      method: 'post',
      success: function(res) {
        if (res.status == 0) {
          let info = res.data,
            cData = that.data.category
          cData = cData.concat(
            info.map(item => {
              return Object.assign(
                {
                  attr: 'category_id'
                },
                pickAttrObject(
                  {
                    value: 'id',
                    name: 'name'
                  },
                  item
                )
              )
            })
          )
          cData.splice(1, 0, {
            value: 1,
            attr: 'hot_flag',
            name: '精品'
          })
          that.setData({
            category: cData
          })
          that.getSectionList()
        }
      }
    })
  }
  getSectionList = () => {
    let that = this,
      sdata = that.data.getSectionData
    if (sdata.loading || sdata.nomore) {
      return
    }
    sdata.loading = true
    let param = pickAttrObject(
      {
        section_id: 'communityId',
        category_id: 'activeCategory.value',
        article_style: 'communityInfo.article_style',
        search_value: 'search_value', // 查询值
        sub_app_id: 'franchisee'
      },
      this.data
    )
    param.page = sdata.page
    param.page_size = 10
    param.is_advertise = 1
    param.is_publish = 1
    param = Object.assign({}, param, this.data.listOtherParam)
    if (param.hot_flag > 0) {
      param.category_id = 0
    }
    if (param.orderby === 'distance') {
      // 距离最近排序需要添加参数order，其他排序不用
      param.order = 'asc'
    } else if ('order' in param) {
      delete param.order
    }
    app.sendRequest({
      url: '/index.php?r=AppSNS/GetArticleByPage',
      data: param,
      method: 'post',
      success: function(res) {
        if (res.status == 0) {
          let info = res.data,
            oldData = that.data.sectionList,
            newData = []
          for (let i = 0; i < info.length; i++) {
            let idata = info[i]
            if (!idata.wechat_id) {
              let ctext = that.showEllipsis(idata.content.text || '')
              idata.title = unescape(idata.title.replace(/\\u/g, '%u'))
              idata.content_text = ctext.text
              idata.isellipsis = ctext.isellipsis
              if (idata.content.type == 2) {
                if (idata.content.url.article) {
                  delete idata.content.url.article.body
                  if (idata.content.url.article.type == 3) {
                    idata.content.url.article.cover =
                      app.globalData.cdnUrl +
                      '/zhichi_frontend/static/webapp/images/audio_default.png'
                  }
                }
              }
              let listRecomItem = getRightAttrVal(
                'form_data.list_recommend.recommend_goods[0]',
                idata
              )
              if (listRecomItem) {
                idata.form_data.list_recommend.recommend_goods[0] = pickAttrObject(
                  {
                    name: 'title',
                    price: 'price',
                    image: 'cover',
                    id: 'id',
                    goods_type: 'goods_type',
                    app_id: 'app_id'
                  },
                  listRecomItem
                )
              }
            }
            if ((idata.style == 2 || idata.style == 3) && idata.video_data) {
              idata['video_url'] = ''
            }
            let date = new Date(idata.update_time * 1000)
            idata['month'] = date.getMonth() + 1
            idata['day'] = date.getDate()
            if (idata['month'] < 10) {
              idata['month'] = '0' + String(idata['month'])
            }
            if (idata['day'] < 10) {
              idata['day'] = '0' + String(idata['day'])
            }
            idata.topicMoreOperationModal = {
              index: i,
              isAuthor:
                idata.user_token === (app.getUserInfo() || {})['user_token'],
              articleId: idata.id,
              sectionId: idata.section_id,
              isChargeTop: !!(idata.top_flag == 1 && idata.order_id)
            }
            newData.push(idata)
          }
          if (sdata.page > 1) {
            newData = oldData.concat(newData)
          }
          that.setData({
            sectionList: newData,
            'getSectionData.page': sdata.page + 1
          })
        }
        that.setData({
          'getSectionData.loading': false,
          'getSectionData.nomore': res.is_more == 0 ? true : false
        })
      },
      fail: function(res) {
        that.setData({
          'getSectionData.loading': false
        })
      }
    })
  }
  getCarousel = sId => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=AppSNS/GetArticleByPage',
      data: {
        page: 1,
        section_id: sId,
        is_carousel: 1,
        orderby: 'id',
        page_size: 10,
        sub_app_id: that.data.franchisee
      },
      method: 'post',
      success: function(res) {
        if (res.status == 0) {
          var info = res.data
          that.setData({
            carouselImg: info
          })
        }
      }
    })
  }
  turnToAdDetail = event => {
    if (event.target.dataset.articleType == 3) {
      this.bindEventTapHandler(event)
      return
    }
    let id = event.target.dataset.id
    let franchiseeParam = this.data.franchisee
      ? '&franchisee=' + this.data.franchisee
      : ''
    app.turnToPage(
      '/informationManagement/pages/newsDetail/newsDetail?detail=' +
        id +
        franchiseeParam
    )
  }
  bindEventTapHandler = e => {
    let form = e.target.dataset.eventParams
    let action = form.action
    let sub_app_id = this.data.franchisee
    if (action && form && sub_app_id) {
      customEvent.clickEventHandler[action](form, sub_app_id)
      return
    }
    customEvent.clickEventHandler[action] &&
      customEvent.clickEventHandler[action](form)
  }
  clickTab = e => {
    var that = this
    if (this.data.currentTab === e.target.dataset.current) {
      return false
    } else {
      that.setData({
        currentTab: e.target.dataset.current
      })
    }
  }
  announceModal = e => {
    this.setData({
      closeDec: true,
      noticeDec: e.target.dataset.text
    })
  }
  showIcon = () => {
    this.setData({
      closeDec: true
    })
  }
  closeIcon = () => {
    this.setData({
      closeDec: false
    })
  }
  stopEvent = e => {
    let that = this
    let video_id = e.target.dataset.id
    let index = e.target.dataset.index
    let sectionList = that.data.sectionList
    if (!sectionList[index].video_url) {
      app.getVideoUrlById(video_id, function(res) {
        sectionList[index].video_url = res
        that.setData({
          sectionList: sectionList,
          video_url: res
        })
      })
    }
    return false
  }
  tapCategory = event => {
    let { attr, value, index } = event.target.dataset,
      activeCategory = this.data.category[index],
      newdata = {}
    if (attr === 'hot_flag') {
      newdata['listOtherParam.hot_flag'] = value
    } else if (attr === 'category_id') {
      newdata['listOtherParam.hot_flag'] = 0
    }
    newdata.activeCategory = activeCategory
    newdata.sectionList = []
    newdata.getSectionData = {
      page: 1,
      loading: false,
      nomore: false
    }
    this.setData(newdata)
    this.getSectionList()
  }
  onReachBottom = event => {
    this.getSectionList()
  }
  oldscrolltop = 0
  onPageScroll = ({ scrollTop }) => {
    let showBackTopBtn = this.data.showBackTopBtn,
      showFlag = scrollTop < this.oldscrolltop && scrollTop
    if (showBackTopBtn ^ showFlag) {
      this.setData({
        showBackTopBtn: showFlag
      })
    }
    this.oldscrolltop = scrollTop
  }
  bindKeyInput = event => {
    let val = event.target.value
    this.setData({
      search_value: val
    })
  }
  bindconfirmInput = event => {
    this.setData({
      sectionList: [],
      getSectionData: {
        page: 1,
        loading: false,
        nomore: false
      }
    })
    this.getSectionList()
  }
  imgLoad = event => {
    let owidth = event.detail.width,
      oheight = event.detail.height,
      index = event.target.dataset.index,
      path = event.target.dataset.path,
      oscale = owidth / oheight,
      cwidth = 290,
      cheight = 120,
      ewidth,
      eheight
    if (this.data.communityInfo.article_style == 2) {
      cwidth = 240
    }
    if (oscale > cwidth / cheight) {
      ewidth = cwidth
      eheight = cwidth / oscale
    } else {
      ewidth = cheight * oscale
      eheight = cheight
    }
    this.setData({
      [path]: `width:${ewidth}px;height:${eheight}px;`
    })
  }
  showEllipsis = oldtext => {
    let that = this,
      padding = that.data.communityInfo.article_style == 2 ? 70 : 25,
      newtext = '',
      newtextarr = [],
      textarr = oldtext.split(/\n|\\n/),
      eachline = ((app.getSystemInfoData().windowWidth - padding) / 12) * 2,
      total_line_num = 2,
      has_line_num = 0,
      isellipsis = false
    for (let i = 0; i < textarr.length; i++) {
      let len = that.stringLength(textarr[i]),
        lenline = Math.ceil(len / eachline)
      if (has_line_num + lenline >= total_line_num) {
        let spare_line = total_line_num - has_line_num
        newtextarr.push(
          that.subString(textarr[i], spare_line * eachline - 16) + '...'
        )
        isellipsis = true
        break
      } else {
        has_line_num += lenline
        newtextarr.push(textarr[i])
      }
    }
    if (isellipsis) {
      newtext = newtextarr
    } else {
      newtext = textarr
    }
    return {
      text: newtext,
      isellipsis: isellipsis
    }
  }
  stringLength = str => {
    let realLength = 0,
      len = str.length,
      charCode = -1
    for (let i = 0; i < len; i++) {
      charCode = str.charCodeAt(i)
      if (charCode > 128) {
        realLength += 2
      } else {
        realLength += 1
      }
    }
    return realLength
  }
  subString = (str, len) => {
    let newLength = 0,
      newStr = '',
      chineseRegex = /[^\x00-\xff]/g,
      singleChar = '',
      strLength = str.replace(chineseRegex, '**').length
    for (let i = 0; i < strLength; i++) {
      singleChar = str.charAt(i).toString()
      if (singleChar.match(chineseRegex) != null) {
        newLength += 2
      } else {
        newLength++
      }
      if (newLength > len) {
        break
      }
      newStr += singleChar
    }
    if (strLength > len) {
      newStr += '...'
    }
    return newStr
  }
  turnToDetail = event => {
    if (isTurnToDetail) {
      return
    }
    isTurnToDetail = true
    let id = event.currentTarget.dataset.id,
      dataLiked = event.currentTarget.dataset.liked,
      phoneNumber = event.currentTarget.dataset.phone,
      article_style = this.data.communityInfo.article_style,
      communityId = this.data.communityId
    let newData = {}
    newData.sectionList = this.data.sectionList.map(function(item, idx) {
      if (item.showCom) {
        delete item.showCom
      }
      if (item.id === id) {
        item.read_count = +item.read_count + 1
      }
      return item
    })
    this.setData(newData)
    let franchiseeParam = this.data.franchisee
      ? '&franchisee=' + this.data.franchisee
      : ''
    app.turnToPage(
      '/informationManagement/pages/communityDetail/communityDetail?detail=' +
        id +
        '&articleStyle=' +
        article_style +
        '&dataLiked=' +
        dataLiked +
        '&phoneNumber=' +
        phoneNumber +
        '&sectionid=' +
        communityId +
        franchiseeParam
    )
    isTurnToDetail = false;
  }
  turnToUsercenter = event => {
    let userInfo = app.getUserInfo()
    if (!userInfo || !userInfo.user_token) {
      app.showModal({
        content: '您暂未登陆，请先登陆'
      })
      return
    }
    let { usertoken, sourcetype } = event.target.dataset
    let franchiseeParam = this.data.franchisee
      ? '&franchisee=' + this.data.franchisee
      : ''
    if (usertoken) {
      franchiseeParam += '&usertoken=' + usertoken + '&sourcetype=' + sourcetype
    }
    app.turnToPage(
      '/informationManagement/pages/communityUsercenter/communityUsercenter?detail=' +
        this.data.communityId +
        franchiseeParam
    )
  }
  turnToNotify = event => {
    let franchiseeParam = this.data.franchisee
      ? '&franchisee=' + this.data.franchisee
      : ''
    let sectionCommentLikeCounts = this.data.sectionCommentLikeCounts
    let commentCount = sectionCommentLikeCounts.comment_count
    let likeCount = sectionCommentLikeCounts.like_count
    let showType = sectionCommentLikeCounts.show_type
    let commentLikeInfo =
      (commentCount > 0 ? '&comment=' + commentCount : '') +
      (likeCount > 0 ? '&like=' + likeCount : '') +
      '&showtype=' +
      showType
    app.turnToPage(
      '/informationManagement/pages/communityNotify/communityNotify?detail=' +
        this.data.communityId +
        franchiseeParam +
        commentLikeInfo
    )
  }
  turnToPublish = event => {
    this.setData({
      'communityPublishType.show': true,
      'communityPublishType.communityPublish': {
        franchisee: this.data.franchisee,
        detail: this.data.communityId,
        reqAudit: this.data.communityInfo.require_audit,
        from: 'communityPage'
      }
    })
  }
  eventStoppropagation = event => {
    event.stopPropagation();
  }
  turnComment = event => {
    let requireArticlePost = this.data.communityInfo.require_article_post
    let requireArticleComment = this.data.communityInfo.require_article_comment
    if (requireArticlePost == 0 || requireArticleComment == 0) {
      app.showModal({
        content: '当前话题圈组不允许评论'
      })
      return
    }
    let {
      sectionId,
      commentId,
      parentCommentId,
      replyto,
      articleId,
      index,
      agentUserToken
    } = event.currentTarget.dataset
    let newData = {}
    if (this.data.communityInfo.article_style == 2) {
      newData['sectionList[' + index + '].showCom'] = false
    }
    newData['showReplyBox'] = true
    newData['replyPlaceholder'] = '评论话题...'
    newData['replyParam.section_id'] = sectionId
    newData['replyParam.article_id'] = articleId
    newData['replyParam.comment_id'] = commentId
    newData['replyParam.parent_comment_id'] = parentCommentId
    newData['replyParam.agent_user_token'] = agentUserToken
    this.setData(newData)
    setTimeout(() => {
      this.setData({
        replyBoxFocus: true
      })
    }, 500)
  }
  articleLike = event => {
    let that = this,
      liked = event.currentTarget.dataset.liked,
      id = event.currentTarget.dataset.id,
      index = event.currentTarget.dataset.index,
      likeCount = +event.currentTarget.dataset.likeCount
    if (likeTap) {
      return
    }
    likeTap = true
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppSNS/PerformLike',
      data: {
        obj_type: 1, // obj_type 1-话题 2-评论
        obj_id: id, // obj_id 话题或评论的id
        sub_app_id: that.data.franchisee || app.getChainId()
      },
      method: 'post',
      success: function(res) {
        if (res.status == 0) {
          if (liked == 1) {
            let newData = {}
            newData['sectionList[' + index + '].is_liked'] = 0
            newData['sectionList[' + index + '].like_count'] = likeCount - 1
            that.setData(newData)
            app.showToast({
              title: '点赞取消'
            })
          } else {
            let newData = {}
            newData['sectionList[' + index + '].is_liked'] = 1
            newData['sectionList[' + index + '].like_count'] = likeCount + 1
            that.setData(newData)
            app.showToast({
              title: '点赞成功'
            })
          }
          that.getArticleLikeImgs(event)
          setTimeout(function() {
            let newData = {}
            newData['sectionList[' + index + '].showCom'] = false
            that.setData(newData)
          }, 480)
          that.getSectionCommentLikeCount()
        }
      },
      complete: function() {
        likeTap = false
      }
    })
  }
  showCommentBox = event => {
    event.stopPropagation()
    let index = event.currentTarget.dataset.index,
      flag = this.data.sectionList[index].showCom,
      newData = {}
    newData.sectionList = this.data.sectionList.map(function(item, idx) {
      if (item.showCom) {
        delete item.showCom
      }
      return item
    })
    if (!flag) {
      newData.sectionList[index].showCom = true
    }
    this.setData(newData)
  }
  getArticleLikeImgs = event => {
    let that = this,
      id = event.target.dataset.id,
      index = event.target.dataset.index
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppSNS/GetLikeLogByPage',
      data: {
        obj_type: 1, // obj_type 1-话题 2-评论
        obj_id: id, // obj_id 话题或评论的id
        sub_app_id: that.data.franchisee
      },
      method: 'post',
      success: function(res) {
        if (res.status == 0) {
          let dataArr = res.data,
            headImgArr = [],
            newData = {}
          dataArr.map(function(item, idx) {
            headImgArr.push({
              headimgurl: item.headimgurl,
              nickname: item.nickname
            })
          })
          newData['sectionList[' + index + '].like'] = headImgArr
          that.setData(newData)
        }
      }
    })
  }
  showActionSheet = event => {
    if (this.data.topicMoreOperationModal.show) {
      this.setData({
        'topicMoreOperationModal.show': false
      })
    }
    let that = this,
      telNum = event.target.dataset.tel,
      telArr = [telNum.substr(0, 3), telNum.substr(3, 4), telNum.substr(7)],
      isIphone = /ios/i.test(app.globalData.systemInfo.platform)
    if (isIphone) {
      app.makePhoneCall({
        phoneNumber: telNum,
        success: function() {},
        fail: function() {}
      })
    } else {
      that.setData({
        phoneNumCall: telArr.join('-'),
        showActionSheet: true
      })
    }
  }
  backPageTop = event => {
    app.pageScrollTo({
      scrollTop: 0
    })
  }
  onShareAppMessage = res => {
    if (this.data.topicMoreOperationModal.show) {
      this.setData({
        'topicMoreOperationModal.show': false
      })
    }
    let shareTitle = this.data.communityInfo.name
    let sharePath = '/informationManagement/pages/communityPage/communityPage'
    if (res && res.from === 'button') {
      let index = res.target.dataset.index,
        id = res.target.dataset.id,
        articleTitle = this.data.sectionList[index].title,
        franchiseeParam = this.data.franchisee
          ? '&franchisee=' + this.data.franchisee
          : '',
        articlePath =
          '/informationManagement/pages/communityDetail/communityDetail?detail=' +
          id +
          franchiseeParam
      shareTitle = articleTitle
      sharePath = articlePath
    }
    sharePath += '&from_share=1'
    return app.shareAppMessage({
      title: shareTitle,
      path: sharePath,
      success: function(res) {
        app.showToast({
          title: '转发成功'
        })
      },
      fail: function(res) {}
    })
  }
  stopPropagation = event => {}
  closeActionSheet = event => {
    this.setData({
      showActionSheet: false
    })
  }
  makePhoneCall = event => {
    let phoneNumCall = this.data.phoneNumCall
    app.makePhoneCall({
      phoneNumber: phoneNumCall.replace(/\-/g, ''),
      success: function() {},
      fail: function() {
        app.showModal({
          content: '播打电话失败'
        })
      }
    })
    this.closeActionSheet()
  }
  cancelReply = () => {
    this.setData({
      showReplyBox: false,
      replyBoxFocus: false
    })
    this.clearCommentInput()
  }
  replyInput = event => {
    this.setData({
      'replyParam.text': event.target.value
    })
  }
  replyTimer = null
  submitReply = (event, repeat) => {
    let that = this,
      { replyParam, franchisee } = this.data
    if (this.replyTimer) {
      clearTimeout(this.replyTimer)
      this.replyTimer = null
    }
    replyParam.text = replyParam.text.trim() // 去除两端的空格
    if (!replyParam.text) {
      if (repeat === undefined) {
        this.replyTimer = setTimeout(() => this.submitReply(event, true), 500)
        return
      }
      app.showModal({
        content: '请填写回复内容'
      })
      return
    }
    if (isReply) {
      return
    }
    isReply = true
    if (!replyParam.sub_app_id && franchisee) {
      // 子店话题详情回复评论
      replyParam.sub_app_id = franchisee
    }
    app.sendRequest({
      url: '/index.php?r=AppSNS/AddComment',
      data: replyParam,
      method: 'post',
      success: function(res) {
        if (res.status == 0) {
          app.showToast({
            title: '回复成功',
            success: function() {
              that.setData({
                showReplyBox: false,
                replyBoxFocus: false
              })
            }
          })
          that.relatePagesRefresh()
          that.clearCommentInput()
        }
        that.refreshOneTopicData({
          articleId: replyParam.article_id
        })
        that.getSectionCommentLikeCount()
      },
      complete: function(res) {
        isReply = false
      }
    })
  }
  tapPrevewPictureHandler = e => {
    app.tapPrevewPictureHandler(e)
  }
  replyFocus = e => {
    if (e.detail.height) {
      let curKbHeight = e.detail.height
      kbHeight = e.detail.height
      if (/iPhone\s?X/i.test(app.globalData.systemInfo.model)) {
        curKbHeight = 365
      }
      this.setData({
        replyBoxFocus: true,
        keyboardHeight: curKbHeight + 'px'
      })
      return
    }
    this.setData({
      replyBoxFocus: true
    })
  }
  replyBlur = e => {
    this.setData({
      replyBoxFocus: false,
      'replyParam.text': e.detail.value
    })
  }
  tapShowSortModal = () => {
    this.setData({
      ['sortModal.show']: true
    })
  }
  tapCloseSortModal = () => {
    this.setData({
      ['sortModal.show']: false
    })
  }
  tapSelectSortItem = e => {
    let that = this
    let { orderby, name } = e.target.dataset
    this.setData({
      ['listOtherParam.orderby']: orderby,
      currentSortbyName: name,
      getSectionData: {
        page: 1,
        loading: false,
        nomore: false
      }
    })
    if (orderby === 'distance' && !this.data.listOtherParam.latitude) {
      this.getCurrentLocation()
        .then(({ latitude, longitude }) => {
          that.setData({
            ['listOtherParam.latitude']: latitude,
            ['listOtherParam.longitude']: longitude
          })
          this.getSectionList()
        })
        .catch(err => {
          console.log(err)
        })
      return
    }
    this.getSectionList()
  }
  getCurrentLocation = () => {
    let locationInfo = app.globalData.locationInfo
    return new Promise((resolve, reject) => {
      if (locationInfo.latitude) {
        resolve(locationInfo)
      }
      app.getLocation({
        success: resolve,
        fail: reject
      })
    })
  }
  replyLineChange = e => {
    let that = this
    let lineHeight = 40
    let marginTop = 45
    let commentContentHeight = lineHeight
    let maxHeight = this.data.commentContentMaxHeight
    app.getBoundingClientRect('#comment-box', rect => {
      if (Array.isArray(rect) && rect[0]) {
        commentContentHeight = e.detail.lineCount * lineHeight
        if (rect[0].top > marginTop && e.detail.lineCount >= 1) {
          if (rect[0].top - marginTop <= lineHeight) {
            maxHeight = commentContentHeight + lineHeight
            that.setData({
              commentContentMaxHeight: maxHeight
            })
          }
          that.setData({
            commentContentHeight
          })
        }
        if (rect[0].top <= marginTop && commentContentHeight <= maxHeight) {
          that.setData({
            commentContentHeight
          })
        }
      }
    })
  }
  replyImageChoose = () => {
    let that = this
    app.chooseImage(imageUrls => {
      that.setData({
        ['replyParam.comment_img_url']: imageUrls[0]
      })
    }, 1)
  }
  replyImagePreview = () => {
    let commentImage = this.data.replyParam.comment_img_url
    app.previewImage({
      current: commentImage
    })
  }
  replyImageDelete = () => {
    this.setData({
      ['replyParam.comment_img_url']: ''
    })
  }
  replyLocationChoose = () => {
    let that = this
    app.chooseLocation({
      success({ name, address, latitude, longitude }) {
        let newdata = {}
        newdata['replyParam.latitude'] = latitude
        newdata['replyParam.longitude'] = longitude
        if (name || address) {
          newdata['replyParam.address'] = name || address
        } else {
          that.getLocByLatAndLng(latitude, longitude, function(res) {
            address = res.address || ''
            that.setData({
              ['replyParam.address']: address
            })
          })
        }
        that.setData(newdata)
      }
    })
  }
  replyLocationDelete = () => {
    this.setData({
      ['replyParam.address']: '',
      ['replyParam.latitude']: '',
      ['replyParam.longitude']: ''
    })
  }
  turnToGoodsDetail = event => {
    let dataset = event.target.dataset
    let id = dataset.id
    let style = dataset.goodsType
    let appId = dataset.appId
    let franchiseeId = appId === app.getAppId() ? this.data.franchisee : appId
    let franchiseeParam = franchiseeId ? '&franchisee=' + franchiseeId : ''
    if (style == 3) {
      app.turnToPage(
        '/pages/toStoreDetail/toStoreDetail?detail=' + id + franchiseeParam
      )
    } else {
      app.turnToPage(
        '/detailPage/pages/goodsDetail/goodsDetail?detail=' +
          id +
          franchiseeParam
      )
    }
  }
  getLocByLatAndLng = (lat, lng, cb) => {
    app.sendRequest({
      url: '/index.php?r=Map/GetAreaInfoByLatAndLng',
      data: {
        latitude: lat,
        longitude: lng
      },
      method: 'post',
      success: function(data) {
        if (data.status == 0 && typeof cb == 'function') {
          cb(data.data)
        }
      }
    })
  }
  clearCommentInput = () => {
    this.setData({
      ['replyParam.text']: '',
      ['replyParam.agent_user_token']: '',
      ['replyParam.address']: '',
      ['replyParam.latitude']: '',
      ['replyParam.longitude']: '',
      ['replyParam.comment_img_url']: '',
      ['replyParam.comment_id']: '',
      ['replyParam.parent_comment_id']: ''
    })
  }
  suspensionTouchEvent = e => {
    let { windowWidth, windowHeight } = this.systemInfo
    let { clientX, clientY } = e.touches[0]
    if (e.type === 'touchstart') {
      let { offsetLeft, offsetTop } = e.target
      let itemOffsetWidth = (windowWidth / 750) * 80,
        itemOffsetHeight = (windowWidth / 750) * 100,
        count = this.data.showBackTopBtn ? 3 : 2
      if (this.data.communityInfo.require_custom_service != 1) {
        // 考虑关闭客服情况
        count = count - 1
      }
      this.suspensionStyle = {
        width: itemOffsetWidth,
        height: itemOffsetHeight * count,
        deltX: clientX - offsetLeft,
        deltY: clientY - offsetTop
      }
      return
    }
    let { width, height, deltX, deltY } = this.suspensionStyle
    let leftVal = clientX - deltX
    let topVal = clientY - deltY
    let maxLeftVal = windowWidth - width
    let maxTopVal = windowHeight - height
    leftVal < 0 && (rightVal = 0)
    leftVal > maxLeftVal && (leftVal = maxLeftVal)
    topVal < 0 && (topVal = 0)
    topVal > maxTopVal && (topVal = maxTopVal)
    this.setData({
      suspensionStyle: `top:${topVal}px;left:${leftVal}px;`
    })
  }
  showTopicOperateModal = event => {
    let dataset = event.target.dataset
    let index = dataset.index
    let targetTopic = this.data.sectionList[index]
    let topicMoreOperationModal = this.data.topicMoreOperationModal
    let articleStyle = this.data.communityInfo.article_style
    let newData = {
      'topicMoreOperationModal.show': true,
      'topicMoreOperationModal.index': index,
      'topicMoreOperationModal.isAuthor':
        targetTopic.user_token === (app.getUserInfo() || {})['user_token'],
      'topicMoreOperationModal.articleId': targetTopic.id,
      'topicMoreOperationModal.sectionId': targetTopic.section_id,
      'topicMoreOperationModal.isChargeTop': !!(
        targetTopic.top_flag == 1 && targetTopic.order_id
      )
    }
    if (topicMoreOperationModal.mode != articleStyle) {
      newData['topicMoreOperationModal.mode'] = articleStyle
    }
    if (topicMoreOperationModal.franchisee !== this.data.franchisee) {
      newData['topicMoreOperationModal.franchisee'] = this.data.franchisee
    }
    if (this.data.communityInfo.require_phone == 1 && targetTopic.phone) {
      newData['topicMoreOperationModal.phone'] = targetTopic.phone
    }
    this.setData(newData)
  }
  cancelTopicMoreOperate = () => {
    this.setData({
      topicMoreOperationModal: {
        mode: '', // 话题风格
        show: false, // 是否显示话题操作弹窗
        index: 0, // 当前被操作话题下标
        isAuthor: false, // 是否是作者自己的话题
        articleId: '', // 话题id
        sectionId: '', // 版块id
        franchisee: '', // 子店app_id
        isChargeTop: false, // 是否为置顶收费话题
        phone: ''
      }
    })
  }
  deleteTopicAct = event => {
    let that = this
    let data = event.target.dataset.data
    let index = data.index
    let articleId = data.articleId
    let sectionId = data.sectionId
    let isChargeTop = data.isChargeTop
    let franchiseeId = data.franchisee
    let content = isChargeTop ? '该话题为付费置顶话题，' : ''
    content += '是否删除这个话题？'
    app.showModal({
      content: content,
      showCancel: true,
      confirm: function() {
        app.sendRequest({
          url: '/index.php?r=AppSNS/DeleteArticle',
          data: {
            article_id: articleId,
            section_id: sectionId,
            sub_app_id: franchiseeId || that.data.franchisee
          },
          method: 'post',
          success: function(res) {
            let list = that.data.sectionList
            list.splice(index, 1)
            that.setData({
              sectionList: list
            })
            that.getSectionInfo(sectionId)
            that.cancelTopicMoreOperate()
            app.globalData.communityPageRefresh = true
            app.showModal({
              content: '删除成功'
            })
          }
        })
      }
    })
  }
  getSectionCommentLikeCount = sectionId => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppSNS/GetSectionCommentOrLikeCount',
      data: {
        section_id: sectionId || this.data.communityId,
        sub_app_id: that.data.franchisee
      },
      success: function(res) {
        let data = res.data
        that.setData({
          sectionCommentLikeCounts: data
        })
      }
    })
  }
  refreshOneTopicData = param => {
    if (!param.articleId) {
      return
    }
    let that = this
    let index = this.data.sectionList.findIndex(
      article => article.id === param.articleId
    )
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppSNS/GetArticleByPage',
      data: {
        article_id: param.articleId,
        sub_app_id: that.data.franchisee,
        page: 1,
        page_size: 10
      },
      method: 'post',
      success: function(res) {
        if (!res.data.length) {
          return
        }
        let topic = res.data[0]
        if (
          topic.form_data.list_recommend &&
          topic.form_data.list_recommend.recommend_goods &&
          topic.form_data.list_recommend.recommend_goods[0]
        ) {
          let {
            title,
            price,
            cover,
            id,
            goods_type,
            app_id
          } = topic.form_data.list_recommend.recommend_goods[0]
          topic.form_data.list_recommend.recommend_goods[0] = {
            name: title,
            price,
            image: cover,
            id,
            goods_type,
            app_id
          }
        }
        topic.topicMoreOperationModal = {
          index: index,
          isAuthor:
            idata.user_token === (app.getUserInfo() || {})['user_token'],
          articleId: idata.id,
          sectionId: idata.section_id,
          isChargeTop: !!(idata.top_flag == 1 && idata.order_id)
        }
        if (index > -1) {
          that.setData({
            ['sectionList[' + index + ']']: topic
          })
        }
      },
      fail: function() {}
    })
  }
  relatePagesRefresh = () => {
    app.globalData.topicRefresh = true
    app.globalData.communityPageRefresh = true
    app.globalData.communityUsercenterRefresh = true
    app.globalData.franchiseeCommunity = true
  }

  privateStopNoop(e) {
    e.stopPropagation()
  }

  render() {
    const {
      backTop,
      communityInfo,
      sectionCommentLikeCounts,
      carouselImg,
      hasCarousel,
      memberInfo,
      memberCount,
      currentTab,
      closeDec,
      noticeDec,
      categoryActive,
      activeCategory,
      category,
      currentSortbyName,
      sortModal,
      sectionList,
      topic,
      vistorUserToken,
      video_url,
      getSectionData,
      suspensionStyle,
      showBackTopBtn,
      showActionSheet,
      phoneNumCall,
      listOtherParam,
      showReplyBox,
      replyBoxFocus,
      keyboardHeight,
      replyPlaceholder,
      replyParam,
      commentContentHeight
    } = this.state
    return (
      <div className="official-page community-page">
        <TopNav title="圈组" />
        <div
          className="communityPage-wrap"
          id="communityPage"
          scrolly="true"
          scrollx="false"
          // onScrollToLower={this.scrollTolower}
          onScroll={this.scrollEvent}
          lowerthreshold="100"
          scrolltop={backTop}
        >
          <div
            className={
              'communityPage-head ' +
              (communityInfo.require_article_post == 1 ? '' : 'fullSearch')
            }
            hidden={communityInfo.article_style == 3}
          >
            <div className="communityPage-search">
              <div
                className="communityPage-search-btn"
                onClick={this.bindconfirmInput}
              >
                <Icon size='xxs' type='search' color="#999"></Icon>
              </div>
              <input
                className="communityPage-search-input"
                id="communityPage-search-input"
                type="text"
                maxLength="64"
                onInput={this.bindKeyInput}
                onClick={this.bindconfirmInput}
                placeholder="搜索"
                placeholderstyle="color: #59607b;"
              />
            </div>
            {communityInfo.require_article_post == 1 && (
              <div
                className={
                  'communityPage-notify-btn ico-moon icon-communityPage-news' +
                  (((sectionCommentLikeCounts.comment_count > 0 ||
                    sectionCommentLikeCounts.like_count > 0) &&
                    ' have-messages') ||
                    '')
                }
                onClick={this.turnToNotify}
                style={convertLineStyleData('color:' + communityInfo.theme_color + ';')}
              ></div>
            )}
            {communityInfo.require_article_post == 1 && (
              <div
                className="communityPage-topic-btn ico-moon icon-usercenter"
                onClick={this.turnToUsercenter}
                style={convertLineStyleData('color:' + communityInfo.theme_color + ';')}
              ></div>
            )}
          </div>
          {carouselImg.length > 0 && <div
            className="communityPage-banner"
            hidden={communityInfo.article_style == 3}
          >
            <Carousel
              className="communityPage-carousel"
              circular="true"
              id="communityPage-carousel"
              indicatorDots="true"
              autoplay="true"
              interval="5000"
              duration="1000"
              indicatorColor="rgba(255,255,255,.45)"
              indicatorActiveColor="rgba(255,255,255,1)"
            >
              {carouselImg.map((item, index) => {
                return (
                  <div
                    key={index}
                    data-id={item.id}
                    style={convertLineStyleData("height: 3.5rem")}
                    onClick={this.turnToDetail}
                  >
                    <img
                      src={item.carousel_img}
                      className="slide-image"
                      lazyload="true"
                    />
                  </div>
                )
              })}
            </Carousel>
          </div>}
          <div
            className="communityPage-main"
            hidden={communityInfo.article_style == 3}
          >
            <div
              className={
                'communityPage-info ' + (hasCarousel ? '' : 'nobanner')
              }
              style={convertLineStyleData(
                'background-image: url(' +
                (hasCarousel
                  ? ''
                  : communityInfo.background_pic || communityInfo.img) +
                ');'
              )}
            >
              <img
                className="communityPage-img"
                src={communityInfo.img}
                lazyload="true"
              />
              <div>
                <span className="communityPage-title">
                  {communityInfo.name}
                </span>
                <div className="communityPage-num">
                  {communityInfo.require_article_post == 1 && (
                    <span>
                      话题
                      <span className="communityPage-topic-num">
                        {communityInfo.xcx_article_count}
                      </span>
                    </span>
                  )}
                  {communityInfo.require_article_post == 1 && (
                    <span>
                      回复
                      <span className="communityPage-comment-num">
                        {communityInfo.xcx_comment_count}
                      </span>
                    </span>
                  )}
                </div>
                <div className="communityPage-headImg">
                  {memberInfo[0] && memberInfo[0].headimgurl && (
                    <img
                      className="headImg"
                      src={memberInfo[0].headimgurl}
                    />
                  )}
                  {memberInfo[1] && memberInfo[1].headimgurl && (
                    <img
                      className="headImg"
                      src={memberInfo[1].headimgurl}
                    />
                  )}
                  {memberInfo[2] && memberInfo[2].headimgurl && (
                    <img
                      className="headImg"
                      src={memberInfo[2].headimgurl}
                    />
                  )}
                  {memberInfo[3] && memberInfo[3].headimgurl && (
                    <img
                      className="headImg"
                      src={memberInfo[3].headimgurl}
                    />
                  )}
                  {memberInfo[4] && memberInfo[4].headimgurl && (
                    <img
                      className="headImg"
                      src={memberInfo[4].headimgurl}
                    />
                  )}
                  <span className="communityPage-description">
                    {memberCount + '个用户参与'}
                  </span>
                </div>
              </div>
            </div>
            {/*  新增公告、简介、成员  */}
            <div className="notice-section">
              <div className="notice-items">
                <div
                  className={
                    'notice-item ' + (currentTab == 0 ? 'current' : '')
                  }
                  data-current="0"
                  onClick={this.clickTab}
                >
                  公告
                </div>
                <div
                  className={
                    'notice-item ' + (currentTab == 1 ? 'current' : '')
                  }
                  data-current="1"
                  onClick={this.clickTab}
                >
                  简介
                </div>
                <div
                  className={
                    'notice-item ' + (currentTab == 2 ? 'current' : '')
                  }
                  data-current="2"
                  onClick={this.clickTab}
                >
                  成员
                </div>
              </div>
              <div className="notice-content">
                {communityInfo.section_notice && communityInfo.section_notice[0] && (
                  <div
                    className={
                      'content-announce ' +
                      (currentTab == 0 ? 'show' : 'hidden')
                    }
                  >
                    <div className="announce-icon ico-moon icon-announce2"></div>
                    <Carousel
                      className="announce-textList"
                      vertical="true"
                      autoplay="true"
                      circular="true"
                      interval="5000"
                    >
                      {communityInfo.section_notice.map((item, index) => {
                        return (
                          <div key={index}>
                            <div
                              className="announce-one"
                              data-text={item}
                              onClick={this.announceModal}
                            >
                              {item}
                            </div>
                          </div>
                        )
                      })}
                    </Carousel>
                  </div>
                )}
                <div
                  className="announceModal"
                  style={convertLineStyleData('display:' + (closeDec ? 'block' : 'none'))}
                  onClick={this.closeIcon}
                >
                  <div
                    className="announce-description"
                    onClick={this.showIcon}
                  >
                    <div className="closeButton" onClick={this.closeIcon}>
                      <img src="http://cdn.jisuapp.cn/static/webapp/images/close.png" />
                    </div>
                    <div className="closeModal">{noticeDec}</div>
                  </div>
                </div>
                <div
                  className={
                    'content-desc ' + (currentTab == 1 ? 'show' : 'hidden')
                  }
                  data-text={communityInfo.description}
                  style={convertLineStyleData(currentTab == 1 ? 'display: -webkit-box;' : '')}
                  onClick={this.announceModal}
                >
                  <span className="desc-text">{communityInfo.description}</span>
                </div>
                <div
                  className={
                    'content-member ' + (currentTab == 2 ? 'show' : 'hidden')
                  }
                >
                  {memberInfo.map((item, index) => {
                    return (
                      <div className="member-item" key={index}>
                        <div
                          className="member-icon"
                          onClick={this.turnToUsercenter}
                          data-usertoken={item.user_token}
                        >
                          <img src={item.headimgurl} />
                        </div>
                        <span className="member-name">{item.nickname}</span>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
            <div className="category-section">
              <div className="communityPage-category" id="communityPage-topic">
                {category.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className={
                        'navli ' +
                        (categoryActive == item.value ? 'active' : '')
                      }
                      style={convertLineStyleData(
                        'color:' +
                        (activeCategory.attr == item.attr &&
                        activeCategory.value == item.value
                          ? communityInfo.theme_color
                          : '') +
                        ';border-color:' +
                        (activeCategory.attr == item.attr &&
                        activeCategory.value == item.value
                          ? communityInfo.theme_color
                          : '') +
                        ';'
                      )}
                      data-value={item.value}
                      data-attr={item.attr}
                      data-index={index}
                      onClick={this.tapCategory}
                    >
                      {item.name}
                    </div>
                  )
                })}
              </div>
              <div
                className="sort-present-aside"
                onClick={this.tapShowSortModal}
              >
                <span>{currentSortbyName || '默认排序'}</span>
              </div>
            </div>
          </div>
          <div
            className="communityPage-type-3-header"
            hidden={communityInfo.article_style != 3}
          >
            <img
              className="communityPage-header-background"
              src={communityInfo.background_pic || communityInfo.img}
            />
            <div className="communityPage-header-name">
              {communityInfo.name}
            </div>
            <img
              className="communityPage-header-image"
              src={communityInfo.headimgurl}
            />
          </div>
          <div className="communityPage-list">
            <div className="communityPage-ul" id="communityPage-ul">
              {sectionList.map((item, sInd) => {
                return (
                  <div key={sInd}>
                    {!item.article_type &&
                      !item.wechat_id &&
                      communityInfo.article_style == 0 && (
                        <div
                          className="tcommunity-topic-type-2"
                          data-liked={item.is_liked}
                          data-id={item.id}
                          data-phone={item.phone}
                        >
                          <div>
                            <div
                              className="card-headimgurl"
                              onClick={this.turnToUsercenter}
                              data-usertoken={item.user_token}
                              data-sourcetype={item.source_type}
                            >
                              <img
                                src={item.headimgurl}
                                data-headimgurl={item.headimgurl}
                                lazyload="true"
                              />
                            </div>
                            <div className="card-authorInfo">
                              <span className="card-publish-author">
                                {item.nickname}
                              </span>
                              {item.top_flag == 1 && (
                                <span className="community-stick"></span>
                              )}
                              {item.hot_flag == 1 && (
                                <span className="community-hot"></span>
                              )}
                              <div className="card-publish-time">
                                {item.add_time}
                              </div>
                            </div>
                            <span
                              className="ico-moon icon-more"
                              data-index={sInd}
                              onClick={this.showTopicOperateModal}
                            ></span>
                          </div>
                          <div className="card-title" onClick={this.turnToDetail}>{item.title}</div>
                          <div
                            className="card-description"
                            style={convertLineStyleData('color:#333;font-size:30rpx;')}
                            onClick={this.turnToDetail}
                          >
                            {item.content.text}
                          </div>
                          {item.content.imgs && item.content.imgs[0] && (
                            <div className="card-decImg">
                              <img
                                src={item.content.imgs[0]}
                                mode="aspectFill"
                                data-img={item.content.imgs[0]}
                                data-imgarr={item.content.imgs}
                                onClick={this.tapPrevewPictureHandler}
                                lazyload="true"
                              />
                            </div>
                          )}
                          {item.content.type == 2 && item.content.url.article && (
                            <div className="tcommunity-topic-link">
                              <div className="link-logo-wrap">
                                <img
                                  className="link-logo"
                                  src={
                                    item.content.url.article.cover ||
                                    item.content.url.article.logo
                                  }
                                  mode="aspectFill"
                                  lazyload="true"
                                />
                                {item.content.url.article.type == 4 && (
                                  <label className="ico-moon icon-news-video-play"></label>
                                )}
                              </div>
                              <span className="link-text">
                                {item.content.url.article.title}
                              </span>
                            </div>
                          )}
                          {item.content.type == 2 && item.content.url.video && (
                            <div className="tcommunity-topic-video">
                              <img
                                className="video-cover"
                                src={item.content.url.video.cover || ''}
                                mode="aspectFill"
                                lazyload="true"
                              />
                              <label className="ico-moon icon-news-video-play"></label>
                            </div>
                          )}
                          {item.form_data.list_recommend.recommend_goods && (
                            <div
                              className="card-goods"
                              data-id={
                                item.form_data.list_recommend.recommend_goods[0]
                                  .id
                              }
                              data-goods-type={
                                item.form_data.list_recommend.recommend_goods[0]
                                  .goods_type
                              }
                              data-app-id={
                                item.form_data.list_recommend.recommend_goods[0]
                                  .app_id
                              }
                              onClick={this.turnToGoodsDetail}
                            >
                              <div className="card-goods-img">
                                <img
                                  src={
                                    item.form_data.list_recommend
                                      .recommend_goods[0].image
                                  }
                                />
                              </div>
                              <div className="card-goods-dec">
                                <div className="card-goods-title">
                                  {
                                    item.form_data.list_recommend
                                      .recommend_goods[0].name
                                  }
                                </div>
                                <div className="card-goods-price">
                                  {'¥' +
                                    item.form_data.list_recommend
                                      .recommend_goods[0].price}
                                </div>
                              </div>
                              <div className="card-goods-button">去购买</div>
                            </div>
                          )}
                          <div className="card-bottom">
                            <div
                              className="card-reading"
                              data-id={item.id}
                              data-index={sInd}
                            >
                              <span className="ico-moon icon-communityPage-read icon-communityPage-read-cover"></span>
                              {item.read_count}
                            </div>
                            <div style={convertLineStyleData('width:50%;text-align:right;')}>
                              <div
                                className="card-thumbs"
                                data-id={item.id}
                                data-liked={item.is_liked}
                                data-index={sInd}
                                data-like-count={item.like_count}
                                onClick={this.articleLike}
                              >
                                <span
                                  className="ico-moon icon-community-group-thumb"
                                  style={convertLineStyleData('font-size: 30rpx;')}
                                ></span>
                                <span className="card-num">
                                  {item.like_count}
                                </span>
                              </div>
                              {communityInfo.require_article_post == 1 &&
                                communityInfo.require_article_comment == 1 && (
                                  <div
                                    className="card-reply"
                                    data-comment-id="0"
                                    data-parent-comment-id="0"
                                    data-article-id={item.id}
                                    data-section-id={item.section_id}
                                    data-index={sInd}
                                    onClick={this.turnComment}
                                    data-replyto={item.nickname}
                                    data-agent-user-token={
                                      item.agent_user_token
                                    }
                                  >
                                    <span className="ico-moon icon-goods-customer-service"></span>
                                    {item.comment_count > 0 ? <span className="card-num">
                                      {item.comment_count}
                                    </span> : ''}
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>
                      )}
                    {/*  朋友圈样式  */}
                    {!item.article_type &&
                      !item.wechat_id &&
                      communityInfo.article_style == 2 && (
                        <div
                          className="communityPage-li friendType-li"
                        >
                          <div className="community-li-top">
                            <div
                              className="community-li-cover"
                              onClick={this.turnToUsercenter}
                              data-usertoken={item.user_token}
                              data-sourcetype={item.source_type}
                            >
                              <img
                                src={item.headimgurl}
                                data-headimgurl={item.headimgurl}
                                lazyload="true"
                              />
                            </div>
                            <div className="community-li-author">
                              <span className="community-li-name">
                                {item.nickname}
                              </span>
                              {item.top_flag == 1 && (
                                <span className="community-stick"></span>
                              )}
                              {item.hot_flag == 1 && (
                                <span className="community-hot"></span>
                              )}
                              <span
                                className="ico-moon icon-more"
                                data-index={sInd}
                                onClick={this.showTopicOperateModal}
                              ></span>
                              <span className="communityPage-li-title" data-liked={item.is_liked}
                                    data-phone={item.phone}
                                    data-id={item.id}
                                    onClick={this.turnToDetail}>
                                {item.title}
                              </span>
                            </div>
                          </div>
                          <div className="communityPage-li-content" data-liked={item.is_liked}
                              data-phone={item.phone}
                              data-id={item.id}
                              onClick={this.turnToDetail}>
                            {item.content_text.map((ii, iind) => {
                              return (
                                <span key={iind} className="text-p">
                                  {ii}
                                  {item.isellipsis &&
                                    iind == item.content_text.length - 1 && (
                                      <span className="ellipsis-a">全文</span>
                                    )}
                                </span>
                              )
                            })}
                            {item.content.type == 2 &&
                              item.content.url.article && (
                                <div className="tcommunity-topic-link">
                                  <div className="link-logo-wrap">
                                    <img
                                      className="link-logo"
                                      src={
                                        item.content.url.article.cover ||
                                        topic.content.url.article.logo
                                      }
                                      mode="aspectFill"
                                      lazyload="true"
                                    />
                                    {item.content.url.article.type == 4 && (
                                      <label className="ico-moon icon-news-video-play"></label>
                                    )}
                                  </div>
                                  <span className="link-text">
                                    {item.content.url.article.title}
                                  </span>
                                </div>
                              )}
                            {item.content.type == 2 && item.content.url.video && (
                              <div className="tcommunity-topic-video">
                                <img
                                  className="video-cover"
                                  src={item.content.url.video.cover || ''}
                                  mode="aspectFill"
                                  lazyload="true"
                                />
                                <label className="ico-moon icon-news-video-play"></label>
                              </div>
                            )}
                          </div>
                          {item.content.imgs && item.content.imgs[0] && (
                            <div>
                              <div className="communityPage-li-imgli-wrap">
                                <React.Fragment>
                                  {item.content.imgs.map((it, itIdx) => {
                                    return itIdx < 9 ? (
                                      <div
                                        key={itIdx}
                                        style={convertLineStyleData('display:inline-block')}
                                        className="communityPage-li-imgli"
                                      >
                                        <img
                                          src={it}
                                          mode="aspectFill"
                                          data-img={it}
                                          data-imgarr={item.content.imgs}
                                          onClick={
                                            this.tapPrevewPictureHandler
                                          }
                                          lazyload="true"
                                        />
                                      </div>
                                    ) : ''
                                  })}
                                </React.Fragment>
                              </div>
                            </div>
                          )}
                          {/*  目前限制只能添加一个商品  */}
                          {item.form_data.list_recommend.recommend_goods && (
                            <div
                              className="community-topic-one-goods"
                              onClick={this.turnToGoodsDetail}
                              data-id={
                                item.form_data.list_recommend.recommend_goods[0]
                                  .id
                              }
                              data-goods-type={
                                item.form_data.list_recommend.recommend_goods[0]
                                  .goods_type
                              }
                              data-app-id={
                                item.form_data.list_recommend.recommend_goods[0]
                                  .app_id
                              }
                            >
                              <div className="topic-goods-left">
                                <img
                                  src={
                                    item.form_data.list_recommend
                                      .recommend_goods[0].image
                                  }
                                  lazyload="true"
                                />
                              </div>
                              <div className="topic-goods-right">
                                <div className="topic-goods-name">
                                  <span>
                                    {
                                      item.form_data.list_recommend
                                        .recommend_goods[0].name
                                    }
                                  </span>
                                </div>
                                <div className="topic-goods-price">
                                  ¥
                                  <span>
                                    {
                                      item.form_data.list_recommend
                                        .recommend_goods[0].price
                                    }
                                  </span>
                                  <button>购买</button>
                                </div>
                              </div>
                            </div>
                          )}
              
                          <div className="communityPage-li-center">
                            <span className="community-li-time">
                              {item.add_time}
                            </span>
                            <div
                              className="community-li-read"
                              data-id={item.id}
                              data-index={sInd}
                              onClick={this.turnToDetail}
                            >
                              <span>{item.read_count + '浏览量'}</span>
                            </div>
                            <div
                              className="community-li-comment"
                              onClick={this.showCommentBox}
                              data-index={sInd}
                            >
                              <div className="li-comments">
                                <img src="http://cdn.jisuapp.cn/static/webapp/images/comments.png" />
                              </div>
                              <div
                                className={
                                  'comment-box ' + (item.showCom ? 'show' : '')
                                }
                              >
                                <div
                                  data-id={item.id}
                                  data-liked={item.is_liked}
                                  data-index={sInd}
                                  data-like-count={item.like_count}
                                  onClick={this.articleLike}
                                >
                                  <label
                                    className={
                                      'ico-moon ' +
                                      (item.is_liked == 1
                                        ? 'icon-community-thumb-up'
                                        : 'icon-collect')
                                    }
                                  ></label>
                                  <span>
                                    {item.like_count > 0
                                      ? item.like_count
                                      : '点赞'}
                                  </span>
                                </div>
                                {communityInfo.require_article_post == 1 &&
                                  communityInfo.require_article_comment ==
                                    1 && (
                                    <div
                                      data-comment-id="0"
                                      data-parent-comment-id="0"
                                      data-article-id={item.id}
                                      data-section-id={item.section_id}
                                      data-index={sInd}
                                      onClick={this.turnComment}
                                      data-replyto={item.nickname}
                                      data-agent-user-token={
                                        item.agent_user_token
                                      }
                                    >
                                      <label className="ico-moon icon-community_message"></label>
                                      <span>
                                        {item.forum_comment_count > 0
                                          ? item.forum_comment_count
                                          : '评论'}
                                      </span>
                                    </div>
                                  )}
                              </div>
                            </div>
                          </div>
                          {communityInfo.article_style == 2 &&
                            item.like_count > 0 && (
                              <div
                                className={
                                  'communityPage-li-likes ' +
                                  (item.comment.length ? 'border' : '')
                                }
                              >
                                <label className="ico-moon icon-community_like"></label>
                                {item.like.map((item, likeIdx) => {
                                  return (
                                    <span key={likeIdx}>
                                      {likeIdx > 0 && <span>,</span>}
                                      <span>{item.nickname}</span>
                                    </span>
                                  )
                                })}
                              </div>
                            )}
                          {communityInfo.article_style == 2 &&
                            item.comment.length ? (
                              <div className="commuinty-li-replyList" 
                                   onClick={this.turnToDetail}>
                                {item.comment.map((replyItem, replyIdx) => {
                                  return (
                                    <div key={replyIdx}>
                                      {replyItem.nickname}
                                      {replyItem.content.reply_to && (
                                        <div className="replyto">
                                          <span>回复</span>
                                          {replyItem.content.reply_to.nickname}
                                        </div>
                                      )}
                                      {'：' + replyItem.content.text}
                                    </div>
                                  )
                                })}
                                <div
                                  style={convertLineStyleData('color: ' + communityInfo.theme_color)}
                                >
                                  查看全部回复
                                  <span className="ico-moon icon-downarrow"></span>
                                </div>
                              </div>
                            ) : ''}
                        </div>
                      )}
                    {/*  不变样式  */}
                    {!item.article_type &&
                      !item.wechat_id &&
                      communityInfo.article_style == 1 && (
                        <div
                          className="communityPage-li"
                        >
                          <div className="community-li-top">
                            <div
                              className="community-li-cover"
                              onClick={this.turnToUsercenter}
                              data-usertoken={item.user_token}
                              data-sourcetype={item.source_type}
                            >
                              {item.headimgurl ? (
                                <img src={item.headimgurl} />
                              ) : (
                                <img src="http://cdn.jisuapp.cn/zhichi_frontend/static/pc2/user/images/default-avatar2.jpg" />
                              )}
                            </div>
                            <div className="community-li-author">
                              <span className="community-li-name">
                                {item.nickname}
                              </span>
                              {item.top_flag == 1 && (
                                <span className="community-stick"></span>
                              )}
                              {item.hot_flag == 1 && (
                                <span className="community-hot"></span>
                              )}
                              <span
                                className="ico-moon icon-more"
                                data-index={sInd}
                                onClick={this.showTopicOperateModal}
                              ></span>
                            </div>
                          </div>
                          <span className="communityPage-li-title" data-liked={item.is_liked}
                          data-phone={item.phone}
                          data-id={item.id}
                          onClick={this.turnToDetail}>
                            {item.title}
                          </span>
                          <div className="communityPage-li-content" data-liked={item.is_liked}
                          data-phone={item.phone}
                          data-id={item.id}
                          onClick={this.turnToDetail}>
                            {item.content_text.map((ii, iind) => {
                              return (
                                <span key={iind} className="text-p">
                                  {ii}
                                  {item.isellipsis &&
                                    iind == item.content_text.length - 1 && (
                                      <span className="ellipsis-a">全文</span>
                                    )}
                                </span>
                              )
                            })}
                            {item.content.type == 2 &&
                              item.content.url.article && (
                                <div className="tcommunity-topic-link">
                                  <div className="link-logo-wrap">
                                    <img
                                      className="link-logo"
                                      src={
                                        item.content.url.article.cover ||
                                        topic.content.url.article.logo
                                      }
                                      mode="aspectFill"
                                      lazyload="true"
                                    />
                                    {item.content.url.article.type == 4 && (
                                      <label className="ico-moon icon-news-video-play"></label>
                                    )}
                                  </div>
                                  <span className="link-text">
                                    {item.content.url.article.title}
                                  </span>
                                </div>
                              )}
                            {item.content.type == 2 && item.content.url.video && (
                              <div className="tcommunity-topic-video">
                                <img
                                  className="video-cover"
                                  src={item.content.url.video.cover || ''}
                                  mode="aspectFill"
                                  lazyload="true"
                                />
                                <label className="ico-moon icon-news-video-play"></label>
                              </div>
                            )}
                          </div>
                          {item.content.imgs && item.content.imgs[0] && (
                            <div>
                              <div className={"communityPage-li-imgli-wrap communityPage-li-imgli-wrap" + communityInfo.article_style}>
                                <React.Fragment>
                                  {item.content.imgs.map((it, itIdx) => {
                                    return itIdx < 9 ? (
                                      <div
                                        key={itIdx}
                                        style={convertLineStyleData('display:inline-block')}
                                        className="communityPage-li-imgli"
                                      >
                                        <img
                                          src={it}
                                          mode="aspectFill"
                                          data-img={it}
                                          data-imgarr={item.content.imgs}
                                          onClick={
                                            this.tapPrevewPictureHandler
                                          }
                                          lazyload="true"
                                        />
                                      </div>
                                    ) : ''
                                  })}
                                </React.Fragment>
                              </div>
                            </div>
                          )}
                          {item.form_data.list_recommend.recommend_goods && (
                            <div
                              className="communityPage-li-goods"
                              onClick={this.turnToGoodsDetail}
                              data-id={
                                item.form_data.list_recommend.recommend_goods[0]
                                  .id
                              }
                              data-goods-type={
                                item.form_data.list_recommend.recommend_goods[0]
                                  .goods_type
                              }
                              data-app-id={
                                item.form_data.list_recommend.recommend_goods[0]
                                  .app_id
                              }
                            >
                              <div className="goods-left">
                                <img
                                  src={
                                    item.form_data.list_recommend
                                      .recommend_goods[0].image
                                  }
                                  lazyload="true"
                                />
                              </div>
                              <div className="goods-center">
                                <div className="goods-name">
                                  <span>
                                    {
                                      item.form_data.list_recommend
                                        .recommend_goods[0].name
                                    }
                                  </span>
                                </div>
                                <div className="goods-price">
                                  ¥
                                  <span>
                                    {
                                      item.form_data.list_recommend
                                        .recommend_goods[0].price
                                    }
                                  </span>
                                </div>
                              </div>
                              <div className="goods-right">
                                <button>去购买</button>
                              </div>
                            </div>
                          )}
                          <div className="communityPage-li-foot">
                            <div className="communityPage-li-foot-top">
                              <div className="community-li-time">
                                {item.add_time}
                              </div>
                              {item.address && (
                                <div className="communityPage-li-location">
                                  <label className="ico-moon icon-community-location"></label>
                                  {item.address}
                                </div>
                              )}
                            </div>
                            <div className="comunityPage-shareBox-wrap" onClick={this.eventStoppropagation}>
                              <div className="comunityPage-li-shareBox">
                                <span className="topic-share" onClick={showNoDevToast}>
                                  <i className="ico-moon icon-community_share"></i>
                                  <span>{item.spread_count > 0 ? item.spread_count : '分享'}</span>
                                </span>
                                <span className="topic-viewcount" onClick={showNoDevToast}>
                                  <i className="ico-moon icon-community_view"></i>
                                  <span>{item.read_count > 0 ? item.read_count : '浏览'}</span>
                                </span>
                                <span className="topic-rating"
                                      data-comment-id="0"
                                      data-parent-comment-id="0"
                                      data-article-id={item.id}
                                      data-section-id={item.section_id}
                                      data-index={sInd}
                                      onClick={this.turnComment}
                                      data-replyto={item.nickname}
                                      data-agent-user-token={
                                        item.agent_user_token
                                      }>
                                  <i className="ico-moon icon-community_message"></i>
                                  <span>{item.comment_count > 0 ? item.comment_count : '评论'}</span>
                                </span>
                                <span className="topic-voteup" 
                                      data-id={item.id}
                                      data-liked={item.is_liked}
                                      data-index={sInd}
                                      onClick={this.articleLike}
                                      data-like-count={item.like_count}
                                      style={convertLineStyleData(
                                        'color:' +
                                        (item.is_liked == 1 ? '#59607b' : '')
                                      )}>
                                  <i className={`ico-moon ${item.is_liked == 1 ? 'icon-community_praise_fill' : 'icon-community_praise'}`}></i>
                                  <span>{item.like_count > 0 ? item.like_count : '点赞'}</span>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    {/*  第四种样式  */}
                    {!item.article_type &&
                      !item.wechat_id &&
                      communityInfo.article_style == 3 && (
                        <div
                          className="communityPage-li friendType-li margin-top0"
                        >
                          <div className="community-li-top">
                            <div
                              className="community-li-style-4"
                              onClick={this.turnToUsercenter}
                              data-usertoken={item.user_token}
                              data-sourcetype={item.source_type}
                            >
                              <span>{item.day}</span>
                              <span className="community-li-month">
                                {item.month + '月'}
                              </span>
                            </div>
                            <div className="community-li-author community-li-author-4">
                              <span className="community-li-name community-li-name-4">
                                {item.nickname}
                              </span>
                              {item.top_flag == 1 && (
                                <span className="community-stick"></span>
                              )}
                              {item.hot_flag == 1 && (
                                <span className="community-hot"></span>
                              )}
                              <span className="communityPage-li-title communityPage-li-title-4" data-liked={item.is_liked}
                                    data-phone={item.phone}
                                    data-id={item.id}
                                    onClick={this.turnToDetail}>
                                {item.title}
                              </span>
                            </div>
                          </div>
                          <div className="communityPage-li-content communityPage-li-content-4" data-liked={item.is_liked}
                              data-phone={item.phone}
                              data-id={item.id}
                              onClick={this.turnToDetail}>
                            {item.content_text.map((ii, iind) => {
                              return (
                                <span key={iind} className="text-p">
                                  {ii}
                                  {item.isellipsis &&
                                    iind == item.content_text.length - 1 && (
                                      <span className="ellipsis-a">全文</span>
                                    )}
                                </span>
                              )
                            })}
                            {item.content.type == 2 &&
                              item.content.url.article && (
                                <div className="tcommunity-topic-link">
                                  <div className="link-logo-wrap">
                                    <img
                                      className="link-logo"
                                      src={
                                        item.content.url.article.cover ||
                                        topic.content.url.article.logo
                                      }
                                      mode="aspectFill"
                                      lazyload="true"
                                    />
                                    {item.content.url.article.type == 4 && (
                                      <label className="ico-moon icon-news-video-play"></label>
                                    )}
                                  </div>
                                  <span className="link-text">
                                    {item.content.url.article.title}
                                  </span>
                                </div>
                              )}
                            {item.content.type == 2 && item.content.url.video && (
                              <div className="tcommunity-topic-video">
                                <img
                                  className="video-cover"
                                  src={item.content.url.video.cover || ''}
                                  mode="aspectFill"
                                  lazyload="true"
                                />
                                <label className="ico-moon icon-news-video-play"></label>
                              </div>
                            )}
                          </div>
                          <div className="style-4-padding">
                            {item.content.imgs && item.content.imgs[0] && (
                              <div>
                                <div className="communityPage-li-imgli-wrap">
                                  <React.Fragment>
                                    {item.content.imgs.map((it, itIdx) => {
                                      return itIdx < 9 ? (
                                        <div
                                          key={itIdx}
                                          style={convertLineStyleData('display:inline-block')}
                                          className="communityPage-li-imgli"
                                        >
                                          <img
                                            src={it}
                                            mode="aspectFill"
                                            data-img={it}
                                            data-imgarr={item.content.imgs}
                                            onClick={
                                              this.tapPrevewPictureHandler
                                            }
                                            lazyload="true"
                                          />
                                        </div>
                                      ) : ''
                                    })}
                                  </React.Fragment>
                                </div>
                              </div>
                            )}
                            {/*  目前限制只能添加一个商品  */}
                            {item.form_data.list_recommend.recommend_goods && (
                              <div
                                className="community-topic-one-goods community-topic-one-goods-4"
                                onClick={this.turnToGoodsDetail}
                                data-id={
                                  item.form_data.list_recommend
                                    .recommend_goods[0].id
                                }
                                data-goods-type={
                                  item.form_data.list_recommend
                                    .recommend_goods[0].goods_type
                                }
                                data-app-id={
                                  item.form_data.list_recommend
                                    .recommend_goods[0].app_id
                                }
                              >
                                <div className="topic-goods-left">
                                  <img
                                    src={
                                      item.form_data.list_recommend
                                        .recommend_goods[0].image
                                    }
                                    lazyload="true"
                                  />
                                </div>
                                <div className="topic-goods-right topic-goods-right-4">
                                  <div className="topic-goods-name">
                                    <span>
                                      {
                                        item.form_data.list_recommend
                                          .recommend_goods[0].name
                                      }
                                    </span>
                                  </div>
                                  <div className="topic-goods-price">
                                    ¥
                                    <span>
                                      {
                                        item.form_data.list_recommend
                                          .recommend_goods[0].price
                                      }
                                    </span>
                                    <button>购买</button>
                                  </div>
                                </div>
                              </div>
                            )}
                            <div className="communityPage-li-center style-4-li-center">
                              <span className="community-li-time">
                                {item.add_time}
                              </span>
                              <div
                                className="community-li-read"
                                data-id={item.id}
                                data-index={sInd}
                                onClick={this.turnToDetail}
                              >
                                <span>{item.read_count + '浏览量'}</span>
                              </div>
                              {item.topicMoreOperationModal.isAuthor && (
                                <span
                                  className="community-li-detete"
                                  data-data={item.topicMoreOperationModal}
                                  onClick={this.deleteTopicAct}
                                >
                                  删除
                                </span>
                              )}
                              <div
                                className="community-li-comment"
                                onClick={this.showCommentBox}
                                data-index={sInd}
                              >
                                <div className="li-comments">
                                  <img src="http://cdn.jisuapp.cn/static/webapp/images/comments.png" />
                                </div>
                                <div
                                  className={
                                    'comment-box ' +
                                    (item.showCom ? 'show' : '')
                                  }
                                >
                                  <div
                                    data-id={item.id}
                                    data-liked={item.is_liked}
                                    data-index={sInd}
                                    data-like-count={item.like_count}
                                    onClick={this.articleLike}
                                  >
                                    <label
                                      className={
                                        'ico-moon ' +
                                        (item.is_liked == 1
                                          ? 'icon-community-thumb-up'
                                          : 'icon-collect')
                                      }
                                    ></label>
                                    <span>
                                      {item.like_count > 0
                                        ? item.like_count
                                        : '点赞'}
                                    </span>
                                  </div>
                                  {communityInfo.require_article_post == 1 &&
                                    communityInfo.require_article_comment ==
                                      1 && (
                                      <div
                                        data-comment-id="0"
                                        data-parent-comment-id="0"
                                        data-article-id={item.id}
                                        data-section-id={item.section_id}
                                        data-index={sInd}
                                        onClick={this.turnComment}
                                        data-replyto={item.nickname}
                                        data-agent-user-token={
                                          item.agent_user_token
                                        }
                                      >
                                        <label className="ico-moon icon-community_message"></label>
                                        <span>
                                          {item.forum_comment_count > 0
                                            ? item.forum_comment_count
                                            : '评论'}
                                        </span>
                                      </div>
                                    )}
                                </div>
                              </div>
                            </div>
                            {communityInfo.article_style == 3 &&
                              item.like_count > 0 && (
                                <div
                                  className={
                                    'communityPage-li-likes ' +
                                    (item.comment.length ? 'border' : '')
                                  }
                                >
                                  <label className="ico-moon icon-community_like"></label>
                                  {item.like.map((item, likeIdx) => {
                                    return (
                                      <span key={likeIdx}>
                                        {likeIdx > 0 && <span>,</span>}
                                        <span>{item.nickname}</span>
                                      </span>
                                    )
                                  })}
                                </div>
                              )}
                            {communityInfo.article_style == 3 &&
                              item.comment.length ? (
                                <div className="commuinty-li-replyList"
                                     onClick={this.turnToDetail}
                                >
                                  {item.comment.map((replyItem, replyIdx) => {
                                    return (
                                      <div key={replyIdx}>
                                        {replyItem.nickname}
                                        {replyItem.content.reply_to && (
                                          <div className="replyto">
                                            <span>回复</span>
                                            {
                                              replyItem.content.reply_to
                                                .nickname
                                            }
                                          </div>
                                        )}
                                        ：
                                        <span style={convertLineStyleData('color:#333')}>
                                          {replyItem.content.text}
                                        </span>
                                      </div>
                                    )
                                  })}
                                  <div
                                    style={convertLineStyleData(
                                      'color: ' + communityInfo.theme_color
                                    )}
                                  >
                                    查看全部回复
                                    <span className="ico-moon icon-downarrow"></span>
                                  </div>
                                </div>
                              ) : ''}
                          </div>
                        </div>
                      )}
                    {/*  微信广告  */}
                    {item.wechat_id && (
                      <Ad className="ad-block" unitId={item.id}></Ad>
                    )}
                    {/*  广告推荐位  样式一 无图样式 */}
                    {item.article_type == 3 && item.style == 1 && (
                      <div
                        onClick={this.turnToAdDetail}
                        className="advertise-recommend"
                        data-id={item.id}
                        data-article-type={item.article_type}
                        data-event-params={item.form_data.event}
                      >
                        <div
                          className="advertise-author-logo"
                          onClick={this.topicTurnToUsercenter}
                        >
                          <img
                            src={item.cover}
                            alt="头像"
                            lazyload="true"
                          />
                        </div>
                        <div className="advertise-top-right">
                          <div className="advertise-author-name">
                            {item.app_name}
                          </div>
                          <div className="advertise-extension">推广</div>
                          <div className="advertise-text">{item.title}</div>
                          <div className="advertise-dec">{item.content}</div>
                          <div className="advertise-publish-info">
                            <div className="advertise-publish-time">
                              {item.add_time}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {/*  广告推荐位  样式二  图片或者视频在下 */}
                    {item.article_type == 3 && item.style == 2 && (
                      <div
                        onClick={this.turnToAdDetail}
                        className="advertise-recommend"
                        data-id={item.id}
                        data-article-type={item.article_type}
                        data-event-params={item.form_data.event}
                      >
                        <div
                          className="advertise-author-logo"
                          onClick={this.topicTurnToUsercenter}
                        >
                          <img
                            src={item.cover}
                            alt="头像"
                            lazyload="true"
                          />
                        </div>
                        <div className="advertise-top-right">
                          <div className="advertise-author-name">
                            {item.app_name}
                          </div>
                          <div className="advertise-extension">推广</div>
                          <div className="advertise-text">{item.title}</div>
                          <div className="advertise-dec">{item.content}</div>
                          {item.imgs != '' && (
                            <div className="advertise-image">
                              <img src={item.imgs} />
                            </div>
                          )}
                          {item.video_data != '' && (
                            <div
                              className="advertise-image"
                              onClick={this.stopEvent}
                              data-index={sInd}
                              data-id={item.video_data.video_id}
                            >
                              <video
                                id="ad_video"
                                poster={item.video_data.video_lib_img}
                                src={video_url}
                                controls
                              ></video>
                            </div>
                          )}
                          <div className="advertise-publish-info">
                            <div className="advertise-publish-time">
                              {item.add_time}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {/*  广告推荐位 样式三 图片或者视频在上 */}
                    {item.article_type == 3 && item.style == 3 && (
                      <div
                        onClick={this.turnToAdDetail}
                        className="advertise-recommend"
                        data-id={item.id}
                        data-article-type={item.article_type}
                        data-event-params={item.form_data.event}
                      >
                        <div
                          className="advertise-author-logo"
                          onClick={this.topicTurnToUsercenter}
                        >
                          <img
                            src={item.cover}
                            alt="头像"
                            lazyload="true"
                          />
                        </div>
                        <div className="advertise-top-right">
                          <div className="advertise-author-name">
                            {item.app_name}
                          </div>
                          <div className="advertise-extension">推广</div>
                          {item.imgs != '' && (
                            <div className="advertise-image">
                              <img src={item.imgs} />
                            </div>
                          )}
                          {item.video_data != '' && (
                            <div
                              className="advertise-image"
                              onClick={this.stopEvent}
                              data-index={sInd}
                              data-id={item.video_data.video_id}
                            >
                              <video
                                id="ad_video"
                                src={video_url}
                                poster={item.video_data.video_lib_img}
                                controls
                              ></video>
                            </div>
                          )}
                          <div className="advertise-text">{item.title}</div>
                          <div className="advertise-dec">{item.content}</div>
                          <div className="advertise-publish-info">
                            <div className="advertise-publish-time">
                              {item.add_time}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {/*  广告推荐位 样式四 多图样式 图片在下 */}
                    {item.article_type == 3 && item.style == 4 && (
                      <div
                        onClick={this.turnToAdDetail}
                        className="advertise-recommend"
                        data-id={item.id}
                        data-article-type={item.article_type}
                        data-event-params={item.form_data.event}
                      >
                        <div
                          className="advertise-author-logo"
                          onClick={this.topicTurnToUsercenter}
                        >
                          <img
                            src={item.cover}
                            alt="头像"
                            lazyload="true"
                          />
                        </div>
                        {item.imgs.map((item, index) => {
                          return (
                            <div className="advertise-top-right" key={index}>
                              <div
                                className="advertise-author-name"
                                style={convertLineStyleData('margin-bottom:7rpx')}
                              >
                                {item.app_name}
                              </div>
                              <div className="advertise-extension">推广</div>
                              <div className="advertise-text">
                                {item.title}
                              </div>
                              <div className="advertise-dec">
                                {item.content}
                              </div>
                              {item.imgs != '' && (
                                <React.Fragment>
                                  {item.imgs.map((one, index) => {
                                    return (
                                      <div
                                        className="advertise-image-list"
                                        key={index}
                                      >
                                        <img src={one} />
                                      </div>
                                    )
                                  })}
                                </React.Fragment>
                              )}
                              <div className="advertise-publish-info">
                                <div className="advertise-publish-time">
                                  {item.add_time}
                                </div>
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    )}
                  </div>
                )
              })}
              {!!!sectionList.length && (
                <div className="communityPage-li-none">
                  <img
                    src="http://cdn.jisuapp.cn/static/webapp/images/none.png"
                    mode="aspectFill"
                    lazyload="true"
                  />
                  <span>暂无内容</span>
                </div>
              )}
              {getSectionData.nomore && sectionList.length > 0 && (
                <div className="communityPage-li-nomore">没有更多了</div>
              )}
            </div>
          </div>
          <div
            className="communityPage-btns-group"
            style={convertLineStyleData(suspensionStyle || 'bottom:40rpx;right:30rpx;')}
          >
            {communityInfo.require_article_post == 1 && (
              <div
                className="communityPage-publish-btn"
                onClick={showNoDevToast}
                style={convertLineStyleData('background-color:' + communityInfo.theme_color + ';')}
              >
                <img src="https://cdn.jisuapp.cn/static/webapp/images/community/suspension-edit1.png" />
              </div>
            )}
            {communityInfo.require_custom_service == 1 && (
              <div
                className="communityPage-service-btn"
                style={convertLineStyleData('background-color:' + communityInfo.theme_color + ';')}
                onClick={showNoDevToast}
              >
                <img src="https://cdn.jisuapp.cn/static/webapp/images/community/suspension-customer1.png" />
                <button
                  opentype="contact"
                  size="20"
                  sessionfrom="goodsDetail"
                ></button>
              </div>
            )}
            {showBackTopBtn && (
              <div
                className="communityPage-backtop-btn"
                onClick={this.backPageTop}
                style={convertLineStyleData('background-color:' + communityInfo.theme_color + ';')}
              >
                <img src="https://cdn.jisuapp.cn/static/webapp/images/community/suspension-top1.png" />
              </div>
            )}
          </div>
        </div>
        <div
          className="actionSheet-wrap"
          hidden={!showActionSheet}
          onTouchMove={this.privateStopNoop}
        >
          <div className="actionSheet-buttons">
            <button className="phoneNum-btn">{phoneNumCall}</button>
            <button className="call-btn" onClick={this.makePhoneCall}>
              呼叫
            </button>
            <button className="cancel-btn" onClick={this.closeActionSheet}>
              取消
            </button>
          </div>
        </div>
        {/*  话题排序选择弹窗  */}
        {sortModal.show && (
          <div className="topic-sort-modal" onClick={this.tapCloseSortModal}>
            <div className="modal-main" onClick={this.tapSelectSortItem}>
              {sortModal.data.map((item, index) => {
                return (
                  <div
                    key={index}
                    data-orderby={item.value}
                    data-name={item.name}
                    className={
                      'btn ' +
                      (listOtherParam.orderby === item.value ? 'active' : '')
                    }
                  >
                    {item.name}
                  </div>
                )
              })}
            </div>
          </div>
        )}
        {/*  ++++++++2019-3-28-11:11  */}
        {/*  新版评论框  */}
        {showReplyBox && (
          <div
            className="communityPage-comment-mask"
            onClick={this.cancelReply}
          ></div>
        )}
        {showReplyBox && (
          <div
            className="communityPage-comment-box"
            id="comment-box"
          >
            <div className="communityPage-comment-top">
              <textarea
                className="communityPage-comment-input"
                placeholder={replyPlaceholder}
                maxLength="-1"
                value={replyParam.text}
                onInput={this.replyInput}
                onChange={() => {}}
              ></textarea>
              {/*  放置图片、位置  */}
              {(replyParam.comment_img_url || replyParam.address) && (
                <div className="communityPage-comment-others">
                  {replyParam.comment_img_url && (
                    <div
                      className="communityPage-comment-others-image"
                      style={convertLineStyleData(
                        'margin-bottom: ' +
                        (replyParam.address ? '36' : '0') +
                        'rpx;'
                      )}
                    >
                      <img
                        src={replyParam.comment_img_url}
                        mode="aspectFill"
                        onClick={this.replyImagePreview}
                        lazyload="true"
                      />
                      <div
                        className="image-close-icon-box"
                        onClick={this.replyImageDelete}
                      >
                      </div>
                    </div>
                  )}
                  {replyParam.address && (
                    <div
                      className="communityPage-comment-others-location"
                      onClick={this.replyLocationDelete}
                    >
                      <span>{replyParam.address}</span>
                    </div>
                  )}
                </div>
              )}
            </div>
            {/*  上传图片按钮、选择位置按钮、发布按钮  */}
            <div className="communityPage-comment-bottom">
              <div className="communityPage-comment-bottom-left">
              </div>
              <div className="communityPage-comment-bottom-right">
                <div
                  className="communityPage-comment-bottom-right-cancel"
                  onClick={this.cancelReply}
                >
                  <span>取消</span>
                </div>
                <div
                  className="communityPage-comment-bottom-right-send"
                  onClick={this.submitReply}
                >
                  <span>发布</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/community-page/CommunityPage.jsx